/**
 * Actions related to the mobile version of the new planbox.
 *
 * @package Qustodio\Theme
 */

const mobilePlanbox = () => {
  const initSwiper = () => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.qusd-exp-planbox__swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  };

  return {
    init: initSwiper,
  };
};
export default mobilePlanbox();
